// Validación de CURP mexicana (18 caracteres). El formato es la única
// validación; la unicidad NO se exige (dos fichas de orgs distintas pueden
// compartir CURP: es justo la señal que agrupa la identidad global).
const CURP_REGEX = /^[A-Z]{4}\d{6}[HM][A-Z]{5}[A-Z0-9]\d$/

export const normalizeCurp = (value) =>
  (value == null ? '' : String(value)).trim().toUpperCase()

export const isValidCurp = (value) => CURP_REGEX.test(normalizeCurp(value))

// Tabla oficial de valores para el digito verificador (indice = valor).
const CURP_ALPHABET = '0123456789ABCDEFGHIJKLMNÑOPQRSTUVWXYZ'

// Digito verificador (0-9) a partir de los primeros 17 caracteres.
// null si algun caracter no esta en la tabla.
export const curpChecksum = (value) => {
  const c = normalizeCurp(value)
  if (c.length < 17) return null
  let sum = 0
  for (let i = 0; i < 17; i++) {
    const v = CURP_ALPHABET.indexOf(c[i])
    if (v === -1) return null
    sum += v * (18 - i)
  }
  return (10 - (sum % 10)) % 10
}

// Formato valido Y digito #18 correcto.
export const isValidCurpChecksum = (value) => {
  const c = normalizeCurp(value)
  if (!isValidCurp(c)) return false
  const d = curpChecksum(c)
  return d !== null && String(d) === c[17]
}

// Extrae { fecha: 'AAAA-MM-DD', sexo: 'H'|'M' } de una CURP con formato valido.
// El siglo se deduce de la homoclave (caracter 17): digito -> 1900s, letra -> 2000s.
export const curpInfo = (value) => {
  const c = normalizeCurp(value)
  if (!isValidCurp(c)) return { fecha: null, sexo: null }
  const yy = c.slice(4, 6)
  const mm = c.slice(6, 8)
  const dd = c.slice(8, 10)
  const siglo = /\d/.test(c[16]) ? '19' : '20'
  return {
    fecha: `${siglo}${yy}-${mm}-${dd}`,
    sexo: c[10] === 'H' ? 'H' : 'M',
  }
}

const GENERO_TO_SEXO = { Varonil: 'H', Femenil: 'M' }

// Compara la CURP con los datos capturados. fechaOk/sexoOk son null cuando no
// hay con que comparar (campo vacio o CURP no parseable).
export const curpMatchesPerson = (value, person = {}) => {
  const info = curpInfo(value)
  const fecha = person.fecha_nacimiento
  const genero = person.genero
  return {
    fechaOk: fecha && info.fecha ? info.fecha === fecha : null,
    sexoOk: genero && GENERO_TO_SEXO[genero] ? info.sexo === GENERO_TO_SEXO[genero] : null,
  }
}
